import Request from "../Request";

export type EmployeeFilter = 'none' | 'Lisa' | 'Hector' | 'Aaron';

class YoungworldReportService {
    static async getOtbReportData({ clientId, epochMonth }: { clientId: string | number; epochMonth: number; }): Promise<any[]> {
        try {
            const params = { epochMonth };
            const response = await Request.get(`/api/clients/${clientId}/youngworld-reports/otb`, params);
            const data = response?.data || [];
            return data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    static async getFutureQuarterReportData({ clientId, epochMonth, quarterEpochStart }: { clientId: string | number; epochMonth: number; quarterEpochStart?: number; }): Promise<any[]> {
        try {
            const params: any = { epochMonth };
            if (quarterEpochStart !== undefined) {
                params.quarterEpochStart = quarterEpochStart;
            }
            const response = await Request.get(`/api/clients/${clientId}/youngworld-reports/future-quarter`, params);
            const data = response?.data || [];
            return data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    static async getWeeklyReportData({ clientId, epochMonth }: { clientId: string | number; epochMonth: number; }): Promise<any[]> {
        try {
            const params = { epochMonth };
            const response = await Request.get(`/api/clients/${clientId}/youngworld-reports/weekly`, params);
            const data = response?.data || [];
            return data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    // Centralized helper to get class codes by employee
    static getEmployeeClassCodes(employee: EmployeeFilter): number[] {
        // Lazy import to avoid circular deps
        const { LISA_CLASS_CODES, HECTOR_CLASS_CODES, AARON_CLASS_CODES } = require("../../components/reports/youngWorld/YoungWorldConstants");
        switch (employee) {
            case 'Lisa':
                return LISA_CLASS_CODES as number[];
            case 'Hector':
                return HECTOR_CLASS_CODES as number[];
            case 'Aaron':
                return AARON_CLASS_CODES as number[];
            case 'none':
            default:
                return [];
        }
    }
}

export default YoungworldReportService;
